"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
exports.reducer = reducer;
exports.initialState = {
    mode: "ready",
    parsedInputs: undefined
};
function reducer(state, action) {
    switch (action.type) {
        case "set-calculate-mode": {
            if (state.mode !== "ready") {
                return state;
            }
            return Object.assign(Object.assign({}, state), { mode: "calculate", coilType: state.parsedInputs.type, parsedInputs: state.parsedInputs });
        }
        case "calculation-job-received": {
            if (state.mode !== "calculate") {
                return state;
            }
            return Object.assign({}, state);
        }
        case "set-ready-mode":
            return Object.assign(Object.assign({}, state), { mode: "ready", parsedInputs: undefined });
        case "set-done-mode": {
            return Object.assign(Object.assign({}, state), { mode: "done" });
        }
        case "confirm-calculation":
            return Object.assign(Object.assign({}, state), { mode: "ready", parsedInputs: action.parsedInputs });
        case "set-batch-size": {
            return Object.assign({}, state);
        }
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map